import AllocatedHoursCreationPage from "./AllocatedHoursCreationPage";

export default AllocatedHoursCreationPage;